import { httpGet, RequestConfig } from '@pressreader/services';
import { FtsParams } from '@pressreader/types';

import { SearchArticlesDto } from '../types';

function searchArticles(data: FtsParams): Promise<SearchArticlesDto> {
    return httpGet<SearchArticlesDto>('search', 'GetArticles', data);
}

/**
 * Total hit count for a legacy full-text search (`fts/GetCount`). Callers pass a paging window of one item
 * (`pageNumber: 0, pageSize: 1`) and usually a timeout — the count is slow on broad queries.
 */
function getSearchArticlesCount(data: FtsParams, requestConfig?: RequestConfig): Promise<number> {
    return httpGet<number>('fts', 'GetCount', data, requestConfig);
}

export { getSearchArticlesCount, searchArticles };
